import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import showToast from '../../utils/toast';
import AuthLayout from '../../components/auth/AuthLayout';

const ALLOWED_MOBILES = new Set([
  '9876543210',
  '1111111111',
  '9999999999',
  '7777777777',
  '8888888888',
  '2222222222'
]);

const DEMO_RESET_OTP = '123456';

const ForgotPassword = () => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { value } = e.target;
    const formattedValue = value.replace(/\D/g, '');
    setMobile(formattedValue.slice(0, 10));
    if (error) {
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      setError('Please enter a valid 10-digit mobile number.');
      return;
    }

    setLoading(true);
    setError('');

    if (!ALLOWED_MOBILES.has(mobile)) {
      const message = 'Mobile number not registered with any account.';
      setError(message);
      showToast.error(message);
      setLoading(false);
      return;
    }

    localStorage.setItem('resetMobile', mobile);
    localStorage.setItem('resetOtp', DEMO_RESET_OTP);

    showToast.success('OTP sent successfully.');
    showToast.info(`Demo OTP is ${DEMO_RESET_OTP}.`);
    navigate('/verify-otp', { state: { mobile } });
    setLoading(false);
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <AuthLayout
      title="Forgot Password"
      subtitle="Enter your registered mobile number to receive an OTP."
      onBack={handleBackToLogin}
    >
      {error && (
        <div className="toast-error">
          <div className="toast-content">
            <div className="toast-icon">⚠️</div>
            <div className="toast-text">{error}</div>
            <button className="toast-close" onClick={() => setError('')}>
              ×
            </button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Mobile Number</label>
          <input
            type="text"
            className="form-input"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={handleChange}
            maxLength={10}
            required
          />
        </div>

        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;


